module.exports = __webpack_public_path__ + "img/three1Red.1c63380f.jpg";